import { useState, useEffect } from 'react';
import { useSnapshot } from 'valtio';
import { authStore } from '../../store/authStore';
import chatService, { ChatWithLastMessage } from '../services/chatService/ChatService';
import firebaseService from '../services/firebase/FirebaseService';

export const useUnreadChatCount = (): number => {
  const auth = useSnapshot(authStore);
  const userId = auth.user?.id;
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!userId) {
      setUnreadCount(0);
      return;
    }

    let unsubscribe: (() => void) | null = null;

    const initializeChats = async () => {
      try {
        await firebaseService.ensureAuthenticated();
        unsubscribe = chatService.subscribeToUserChats(userId, (chats: ChatWithLastMessage[]) => {
          const total = chats.reduce(
            (sum: number, chat: ChatWithLastMessage) => sum + (chat.unreadCount || 0),
            0,
          );
          setUnreadCount(total);
        });
      } catch (error) {
        setUnreadCount(0);
      }
    };

    initializeChats();

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [userId]);

  return unreadCount;
};
